import { Dispatch, SetStateAction, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Types } from '../../utils/enums'
import { GetUuid } from '../../utils/types/generals'

export type DownloadType = 'pdf' | 'word' | 'excel' | string

const useDownloadWithUuid = (data: {
    getUuid: (
        data: {
            type: DownloadType;
            query?: string;
            id?: string
        }
    ) => Promise<GetUuid>;

    downloadFuntion: (
        data: {
            uuid: string
        }
    ) => Promise<GetUuid>;

    query?: string;
    docName: string;
    errorName?: string;
    id?: string,
    uuid?: string;
    setUuid: Dispatch<SetStateAction<string>>;
}
) => {

    const { t } = useTranslation()

    const ref = useRef<NodeJS.Timeout | null>(null)

    const [download, setDownload] = useState<boolean>(false)

    const [typeDownload, setTypeDownload] = useState<DownloadType>('pdf')

    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS as string,
    })

    const closeOpenSnakbar = () => {
        setOpenSnackbar((prev) => ({
            ...prev,
            open: false,
        }))
    }

    const clearSnackbar = () => {
        if (ref.current) {
            clearTimeout(ref.current)
        }
    }

    const handleDownload = ({ file }: { file: DownloadType }) => {
        setDownload(true)
        setTypeDownload(file)

        setOpenSnackbar({
            message: t('general.waitAMoment'),
            open: true,
            type: Types.INFO,
        })

        clearSnackbar()

        ref.current = setTimeout(closeOpenSnakbar, 3000)

        data
            ?.getUuid({ type: file, query: data?.query, id: data?.id })
            .then((response) => {
                if (!response.errors) {
                    data.setUuid(response.uuid)
                } else {
                    clearSnackbar()

                    setOpenSnackbar({
                        message: data?.errorName ?? t('schedule.snackbar.download.error.pdf'),
                        open: true,
                        type: Types.ERROR,
                    })
                }
            })
            .catch(() => {
                clearSnackbar()

                setOpenSnackbar({
                    message: data?.errorName ?? t('schedule.snackbar.download.error.pdf'),
                    open: true,
                    type: Types.ERROR,
                })
            })
    }

    const getDetailInform = async () => {

        if (data.uuid) {
            data
                ?.downloadFuntion({ uuid: data.uuid })
                .then((response) => {
                    if (response.reportUrl) {
                        data.setUuid('')
                        fetch(response.reportUrl)
                            .then(res => {
                                if (!res.ok) {
                                    throw new Error('Error en la descarga')
                                }
                                return res.blob()
                            })
                            .then(blob => {
                                let extension = ''

                                switch (typeDownload) {
                                    case 'pdf':
                                        extension = '.pdf'
                                        break
                                    case 'excel':
                                        extension = '.xlsx'
                                        break
                                    case 'word':
                                        extension = '.docx'
                                        break
                                }

                                const url = window.URL.createObjectURL(blob)
                                const link = document.createElement('a')
                                link.href = url
                                link.download = `${data.docName}${extension}`
                                document.body.appendChild(link)
                                link.click()
                                document.body.removeChild(link)
                                window.URL.revokeObjectURL(url)
                            })
                            .catch(err => {
                                clearSnackbar()
                                console.error('Error al descargar el archivo:', err)
                                setOpenSnackbar({
                                    message: t('schedule.snackbar.download.error.pdf'),
                                    open: true,
                                    type: Types.ERROR,
                                })
                            })
                    } else {
                        clearSnackbar()

                        setOpenSnackbar({
                            message: data?.errorName ?? t('schedule.snackbar.download.error.pdf'),
                            open: true,
                            type: Types.ERROR,
                        })
                    }
                })
                .catch(() => {
                    clearSnackbar()

                    setOpenSnackbar({
                        message: data?.errorName ?? t('schedule.snackbar.download.error.pdf'),
                        open: true,
                        type: Types.ERROR,
                    })
                })
                .finally(() => {
                    setDownload(false)
                })
        }
    }

    const downloadCSV = () => {
        handleDownload({ file: 'excel' })
    }

    const downloadPDF = () => {
        handleDownload({ file: 'pdf' })
    }

    const downloadWORD = () => {
        handleDownload({ file: 'word' })
    }

    const downloadCustome = (type?: DownloadType) => {
        handleDownload({ file: type ?? 'excel' })
    }

    return { download, openSnackbar, downloadCSV, downloadPDF, downloadWORD, closeOpenSnakbar, downloadCustome, getDetailInform }
}

export { useDownloadWithUuid }
